import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import SEO from "./components/SEO";
import UrgencyBanner from "./components/UrgencyBanner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import AllInOne from "./components/AllInOne";
import Services from "./components/Services";
import HowItWorks from "./components/HowItWorks";
import About from "./components/About";
import Papelaria from "./components/Papelaria";
import Carimbos from "./components/Carimbos";
import Testimonials from "./components/TestimonialsNew";
import Gallery from "./components/Gallery";
import Location from "./components/Location";
import Contact from "./components/Contact";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO />
      <UrgencyBanner />
      <Header />
      <Hero />
      <AllInOne />
      <Services />
      <Papelaria />
      <Carimbos />
      <HowItWorks />
      <About />
      <Gallery />
      <Testimonials />
      <Location />
      <Contact />
      <FinalCTA />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
